export enum CommandType {
  REFRESH = 'refresh',
  SELFCONF = 'selfconf',
  BACKUP = 'backup',
  THRESHOLD = 'threshold',
  UNBLOCK = 'unblock',
  GET_ALARM = 'getalarm',
  CONFIGURE = 'configure',
  SENDFCFG = 'SENDFCFG',
  GPS = 'GPS',
  SRTM = 'SRTM',
  TRANSPORT = 'TRANSPORT',
  RESET = 'RESET',
  SELFCONF_CHANNEL_1 = 'SELFCONF_CHANNEL_1',
  SELFCONF_CHANNEL_2 = 'SELFCONF_CHANNEL_2',
  SELFCONF_DEVICE = 'SELFCONF_DEVICE',
  DIAGNOSTIC = 'DIAGNOSTIC',
  RESTART_GREENGRASS = 'restart_greengrass',
  RESTART_DEVICE = 'restart_device'
}
